
import React from 'react';

interface NavigationIndicatorsProps {
  totalSlides: number;
  currentSlide: number;
  onSlideClick: (index: number) => void;
}

const NavigationIndicators: React.FC<NavigationIndicatorsProps> = ({ 
  totalSlides, 
  currentSlide,
  onSlideClick
}) => {
  return (
    <div className="flex justify-center items-center gap-4 mt-8">
      <div className="flex gap-2">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            onClick={() => onSlideClick(index)}
            className={`w-3 h-3 rounded-full transition-colors cursor-pointer hover:scale-110 ${
              index === currentSlide ? 'bg-sage' : 'bg-sage/30 hover:bg-sage/50'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
      <div className="text-sm text-muted-foreground font-inter">
        {currentSlide + 1} of {totalSlides}
      </div>
    </div>
  );
};

export default NavigationIndicators;
